import axios from ".";

/**
 * Get batches for authorization with pagination and filtering
 * @param page Page number (starts at 1)
 * @param pageSize Number of items per page
 * @param brandIds Optional array of brand IDs to filter batches
 * @returns Promise with paginated batch data
 */
export const getBatchesForAuthorization = async (
  page: number = 1,
  pageSize: number = 20,
  brandIds?: string[]
) => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString(),
  });

  if (brandIds && brandIds.length > 0) {
    brandIds.forEach((id) => params.append("brand_ids", id));
  }

  return axios.get(`/authorization/batches?${params.toString()}`);
};

/**
 * Get brands for authorization filtering
 * @returns Promise with brand data
 */
export const getBrandsForAuthorization = async () => {
  return axios.get(`/authorization/brands`);
};

/**
 * Get copywriters for authorization
 * @returns Promise with copywriter data
 */
export const getCopywritersForAuthorization = async () => {
  return axios.get(`/authorization/copywriters`);
};

/**
 * Get jobs for authorization
 * @param batchId The ID of the batch
 * @returns Promise with job data
 */
export const getJobsForAuthorization = async (batchId: string) => {
  return axios.get(`/authorization/jobs?batch_id=${batchId}`);
};

/**
 * Set bulk job authorizations for a copywriter
 * @param userId The ID of the copywriter user
 * @param jobIds Array of job IDs to assign
 * @param role The role of the copywriter (Editor or Reviewer)
 * @returns Promise with created authorizations
 */
export const setBulkJobAuthorizations = async (
  userId: string,
  jobIds: string[],
  roles: ("Editor" | "Reviewer")[]
) => {
  return axios.post(`/authorization/set-job-authorizations/bulk`, {
    user_id: userId,
    job_ids: jobIds,
    functions: roles,
  });
};

/**
 * Delete a job authorization
 * @param authorizationIds Array of authorization IDs to delete
 * @returns Promise with deleted authorization
 */
export const deleteJobAuthorization = async (authorizationIds: string[]) => {
  return axios.post(`/authorization/delete-job-authorization/bulk`, {
    ids: authorizationIds,
  });
};
